const Intro = () => {
  const playSound = () => {
    const audio = new Audio("/sfx/cast_vote.aac");
    audio.play();
  };
  return (
    <div className="flex flex-col items-center" id="mainComp_G">
      <div id="mainComp" className="relative flex justify-center mt-16">
        <div id="mainLogo_G" className="relative flex justify-center">
          <div id="mainLogo" className="relative flex justify-center gap-4">
            <div className="flex-shrink-0">
              <img src="/imgs/logo1.png" alt="Live Your Best Lip!" className="w-[209px] h-auto" id="logo1" />
            </div>
            <div className="flex-shrink-0 flex items-center overflow-hidden">
              <img src="/imgs/logo2.png" alt="Live Your Best Lip!" className="w-[290px] h-auto" id="logo2" />
            </div>
          </div>
        </div>
      </div>

      <div
        className="relative mt-[0px]"
        id="KV"
        style={{ height: "450px", width: "100%", display: "flex", justifyContent: "center" }}
      >
        <div className="absolute w-full max-w-[680px] h-auto KV-1_G" id="KV-1_G">
          <img src="/imgs/KV-1.png" alt="Live Your Best Lip!" className="w-full h-auto" id="KV-1" />
        </div>
        <div className="absolute w-full max-w-[680px] h-auto KV-1_G" id="KV-1_G2">
          <img src="/imgs/KV-1B.png" alt="Live Your Best Lip!" className="w-full h-auto" id="KV-1B" />
        </div>
        <div className="absolute w-full max-w-[680px] h-auto" id="KV-2_G">
          <img src="/imgs/KV-2.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="KV-2" />
        </div>
        <div className="absolute w-full max-w-[680px] h-auto floating">
          <img src="/imgs/KV-3.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="KV-3" />
        </div>
        <div className="absolute w-full max-w-[680px] h-auto floating2">
          <img src="/imgs/KV-4.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="KV-4" />
        </div>
        <div className="absolute w-full max-w-[680px] h-auto" id="KV-5_G">
          <img src="/imgs/KV-5.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="KV-5" />
        </div>
        <div className="absolute w-full max-w-[680px] h-auto" id="KV-6-7_G">
          <img src="/imgs/KV-6.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="KV-6" />
          <img src="/imgs/KV-7.png" alt="Live Your Best Lip!" className="absolute w-full h-auto" id="KV-7" />
        </div>
      </div>

      {/* Hidden: vote and win amazing prizes section */}

      {/* Hidden: vote and win section */}
    </div>
  );
};
export default Intro; // ✅ Ensure default export
